import { type FetchVoteTokenByVoteTokenIdData, minutesToMs, type VoteToken } from '@capsicum/common';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { fetchVoteTokenByVoteToken } from '../api/fan-token';

export const useFanTokenQuery = <TData = FetchVoteTokenByVoteTokenIdData>(
	tokenId?: string,
	select?: (data: VoteToken) => TData,
	options?: Omit<UseQueryOptions<VoteToken, unknown>, 'queryFn' | 'queryKey' | 'select'>
) =>
	useQuery({
		enabled: !!tokenId && options?.enabled,
		queryFn: () =>
			fetchVoteTokenByVoteToken({
				voteTokenId: tokenId as string
			}),
		queryKey: ['voteToken', tokenId],
		select,
		staleTime: minutesToMs(5),
		...options
	});
